import { Box, CircularProgress, IconButton } from '@mui/material';
import React from 'react';
import { ArrowBack } from 'components/icons';
import CameraComponent from './CameraComponent';

interface ScanningComponentProps {
	setLicensePlateNumber: (val: string) => void;
	setSelectedState: (val: string) => void;
	setIsCameraOn: (val: boolean) => void;
	capturedImage: string | null;
	setCapturedImage: (val: string | null) => void;
	onCleanScan?: (plate: string, state: string) => void;
}

const ScanningComponent: React.FC<ScanningComponentProps> = ({
	setLicensePlateNumber,
	setSelectedState,
	setIsCameraOn,
	capturedImage,
	setCapturedImage,
	onCleanScan,
}) => {
	const [isLoading, setIsLoading] = React.useState(false);

	return (
		<Box display="flex" flexDirection="column" alignItems="center">
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					position: 'relative',
					width: '100%',
				}}
			>
				{isLoading && capturedImage ? (
					<img
						src={capturedImage}
						alt="Captured"
						style={{
							width: '100%',
							height: 'auto',
						}}
					/>
				) : (
					<Box
						display={'flex'}
						flexDirection={'column'}
						width={'100%'}
					>
						<Box
							display={'flex'}
							justifyContent={'space-between'}
							width={'100%'}
						>
							<IconButton
								onClick={() => {
									setIsCameraOn(false);
								}}
								color="error"
								disabled={isLoading}
								aria-label="Cancel scan"
								sx={{
									border: '1px solid',
									borderColor: 'text.error',
								}}
							>
								<ArrowBack />
							</IconButton>
						</Box>
						<CameraComponent
							setCapturedImage={setCapturedImage}
							setIsLoading={setIsLoading}
							setLicensePlateNumber={setLicensePlateNumber}
							setSelectedState={setSelectedState}
							setIsCameraOn={setIsCameraOn}
							onCleanScan={onCleanScan}
						/>
					</Box>
				)}

				{isLoading && (
					<Box
						sx={{
							position: 'absolute',
							top: 0,
							left: 0,
							width: '100%',
							height: '100%',
							backgroundColor: 'rgba(0, 0, 0, 0.5)',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							borderRadius: '8px',
						}}
					>
						<CircularProgress color="inherit" />
					</Box>
				)}
			</Box>
		</Box>
	);
};

export default ScanningComponent;
